<template>
    <div class="must-have-exactly-one-root-element">

        <!-- Menu -->
        <menu-obchod
            @hideSideMenu="hideSideMenu"
            :kravicka="kravicka"
            :sideMenu="sideMenu"
        />

        <!-- Shop phone -->
        <button @click="sideMenu = !sideMenu" id="openShopMenu" class="btn --primary d-xl-none" style="z-index:61"><span class="icon"></span></button>

        <main class="shopMain --lightBg">
            <div class="shopHeader --whiteBg d-flex">
                <h2 class="mb-0">Obchod</h2>

                <!-- Header -->
                <header-obchod
                    @updateProfil="emitUpdateProfil"
                    :profil="profil"
                />
            </div>

            <!-- Alert box -->
            <div v-if="responseText != ''" :class="'alert alert-dismissible fade show --shopAlert alert-'+responseType" role="alert">
                <p class="mb-0">
                    <span :class="'icon --'+responseType"></span>{{ responseText }}
                </p>

                <button @click="responseText = ''" type="button" class="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <!-- Produkty -->
            <obchod-product-grid
                :obchod="obchod"
                :kategoria="kategoria"
                @buyProduct="buyShopProduct"
            >
            </obchod-product-grid>

        </main>

    </div>
</template>



<script>
    import EventService      from '@/services/EventService.js'
    import HeaderObchod      from '../partials/HeaderObchod.vue'
    import MenuObchod        from '../partials/MenuObchod.vue'
    import ObchodProductGrid from '../partials/ObchodProductGrid.vue'
    export default {
        components: {
            HeaderObchod,
            MenuObchod,
            ObchodProductGrid
        },
        props: [
            'profil',
            'kravicka',
            'obchod',
            'kategoria'
        ],
        mounted() {
            this.getKravickaData()
        },
        data() {
            return {
                ownedItemsArr: [],
                sideMenu: false,

                responseType: '',
                responseText: ''
            }
        },
        methods: {
            // emit
            emitUpdateProfil() {
                this.$emit('updateProfil')
            },

            hideSideMenu() {
                this.sideMenu = false
            },


            // mounted
            getKravickaData() {
                if (typeof(this.kravicka.id) == 'undefined' || this.$route.params.kravicka_id != this.kravicka.id) {
                    this.$emit('update:kravicka', {})
                    EventService.getKravickaData(this.$route.params.kravicka_id)
                        .then(response => {
                            //console.log(response.data)
                            this.param_global = Number((response.data.data[0].kravicka_param_global).toFixed(0))
                            this.$emit('update:kravicka', response.data.data[0])

                            // vlastnené produkty
                            var inv = response.data.data[0].repozitar_kravicky
                            for (var i = 0; i < inv.length; i++) {
                                if (inv[i].herny_produkt_id.herny_produkt_kategoria == "background" || inv[i].herny_produkt_id.herny_produkt_kategoria == "fun" || parseInt(inv[i].repozitar_kravicky_usage_type) >= 999) {
                                    //this.ownedItemsArr[inv[i].herny_produkt_id.id] = inv[i].herny_produkt_id.id
                                    this.ownedItemsArr[inv[i].herny_produkt_id.id] = parseInt(inv[i].repozitar_kravicky_usage_type)
                                }
                            }

                            this.getObchodData()
                        })
                        .catch(error => {
                            this.responseType = 'warning'
                            this.responseText = error
                        })

                } else {
                    //console.log(this.kravicka)
                    this.param_global = Number((this.kravicka.kravicka_param_global).toFixed(0))

                    // vlastnené produkty
                    var inv = this.kravicka.repozitar_kravicky
                    for (var i = 0; i < inv.length; i++) {
                        if (inv[i].herny_produkt_id.herny_produkt_kategoria == "background" || inv[i].herny_produkt_id.herny_produkt_kategoria == "fun" || parseInt(inv[i].repozitar_kravicky_usage_type) >= 999) {
                            //this.ownedItemsArr[inv[i].herny_produkt_id.id] = inv[i].herny_produkt_id.id
                            this.ownedItemsArr[inv[i].herny_produkt_id.id] = parseInt(inv[i].repozitar_kravicky_usage_type)
                        }
                    }

                    this.getObchodData()
                }
            },

            getObchodData() {
                if (typeof(this.obchod[0]) == 'undefined') {
                    EventService.getObchodData()
                        .then(response => {
                            //console.log(response.data)

                            // disable buy pre vlastnené produkty
                            var prod = response.data.data
                            for (var i = 0; i < prod.length; i++) {
                                prod[i].disabled = 0
                                if (typeof(this.ownedItemsArr[prod[i].id]) != "undefined") {
                                    prod[i].disabled = 1
                                }
                            }

                            this.$emit('update:obchod', prod)
                        })
                        .catch(error => {
                            this.responseType = 'warning'
                            this.responseText = error
                        })
                }
            },


            // click
            buyShopProduct: function (index, item) {
                if (!this.isDisabled) {
                    this.isDisabled = true

                    // prehraj zvukovú nahrávku
                    this.playSound('assets/audio/obchod.wav')

                    // zakúp produkt
                    this.buyProduct(index, item.id, item.herny_produkt_cena, item.pocet_pouziti, item.herny_produkt_kategoria, item.img_url, item.herny_produkt_img_obchode)
                }
            },

            playSound: function(src) {
                var sound = new Audio(src)
                sound.play()
            },

            buyProduct(index, produkt_id, produkt_cena, pocet_pouziti, kategoria, img_url, paralax) {
                EventService.buyProduct(this.kravicka.id, produkt_id)
                    .then(response => {
                        //console.log(response.data)
                        this.responseType = response.data.code
                        this.responseText = response.data.data

                        if (response.data.code == 'success') {

                            /*nastav nové pozadie
                            if (kategoria == "background") {
                                for (var i = 0; i < this.profil.pouzivatel_id.kravicky_pouzivatela.length; i++) {
                                    if (this.profil.pouzivatel_id.kravicky_pouzivatela[i].id == this.kravicka.id) {
                                        this.profil.pouzivatel_id.kravicky_pouzivatela[i].kravicka_pozadie_profil = img_url
                                        this.kravicka.kravicka_pozadie = paralax
                                    }
                                }
                            }*/

                            // odrátaj dukáty
                            this.profil.pouzivatel_id.pouzivatel_wallet -= parseFloat(produkt_cena)
                            this.$emit('update:profil', this.profil)

                            // ak je produkt v inventári pridaj počet KS
                            var exist = 0
                            for (var i = 0; i < this.kravicka.repozitar_kravicky.length; i++) {
                                if (this.kravicka.repozitar_kravicky[i].herny_produkt_id.id == produkt_id) {
                                    this.kravicka.repozitar_kravicky[i].repozitar_kravicky_usage_type = parseFloat(this.kravicka.repozitar_kravicky[i].repozitar_kravicky_usage_type) + parseFloat(pocet_pouziti)
                                    exist = 1

                                    // disable opakované zakúpenie produktu ak dosiahne 999 Ks a viac
                                    if (this.kravicka.repozitar_kravicky[i].repozitar_kravicky_usage_type >= 999) {
                                        this.obchod[index].disabled = 1
                                        this.$emit('update:obchod', this.obchod)
                                    }
                                }
                            }

                            // ak ešte nieje v inventári kravičky (prvé zakúpenie produktu)
                            if (exist == 0) {
                                var p = this.obchod[index]
                                var newItem = {
                                    id: response.data.id,
                                    repozitar_kravicky_category: p.herny_produkt_kategoria,
                                    repozitar_kravicky_usage_type: p.pocet_pouziti,
                                    herny_produkt_id: {
                                        herny_produkt_cena: p.herny_produkt_cena,
                                        herny_produkt_hlasky: p.herny_produkt_hlasky,
                                        herny_produkt_img_inventar: p.herny_produkt_img_inventar,
                                        herny_produkt_popis_produktu: p.herny_produkt_popis_produktu,
                                        //herny_produkt_kategoria: p.herny_produkt_kategoria,
                                        herny_produkt_meno: p.herny_produkt_meno,
                                        herny_produkt_percenta: p.herny_produkt_percenta,
                                        herny_produkt_zvuk: p.herny_produkt_zvuk,
                                        herny_produkt_zvuk_animacia: p.herny_produkt_zvuk_animacia,
                                        herny_produkty_animacie_id: p.herny_produkty_animacie_id,
                                        herny_produkt_povoleny: p.herny_produkt_povoleny,
                                        id: p.id,
                                        pocet_pouziti: p.pocet_pouziti
                                    }
                                }

                                this.kravicka.repozitar_kravicky.push(newItem)

                                // disable opakované zakúpenie produktu
                                if (parseInt(p.pocet_pouziti) == 999) {
                                    this.obchod[index].disabled = 1
                                    this.$emit('update:obchod', this.obchod)
                                }
                            }

                            this.$emit('update:kravicka', this.kravicka)

                            // achievements
                            this.prepAchievements(produkt_id, kategoria)
                        } else {
                            this.isDisabled = false
                        }
                    })
                    .catch(error => {
                        this.responseType = 'warning'
                        this.responseText = error
                    })
            },


            // achievements
            prepAchievements(produkt_id, kategoria) {
                // achievements ids (1, 10 bgs)
                if (kategoria == "background") {
                    var uid  = 8
                    var uid2 = 4
                }

                // achievements ids (lucerka, seno, datelina, kukurica, slnecnica, trava, hreben, kefa)
                var enumUspechy = { '6':15, '7':33, '14':7, '19':5, '24':14, '34':3, '136':29, '15':1 }
                if (typeof(enumUspechy[produkt_id]) != 'undefined') {
                    var uid = enumUspechy[produkt_id]
                }

                if (typeof(uid) != 'undefined') { this.achievements(uid) }
                if (typeof(uid2) != 'undefined') { this.achievements(uid2) }
                this.isDisabled = false
            },

            achievements(uid) {
                var key = EventService.checkAchievementProgress(this.profil, uid)
                if (key > -2) {
                    EventService.setAchievementProgress(this.profil, uid)
                        .then(response => {
                            console.log(response.data)
                            //this.responseType = response.data.code
                            //this.responseText = response.data.data

                            sessionStorage.removeItem("login")
                            sessionStorage.setItem("album-uspechy", "refresh")

                            if (key == -1) {
                                this.$emit('updateProfil')
                            } else {
                                this.profil.pouzivatel_id.album_pouzivatela[key].repozitar_albumu_current += 1
                                this.$emit('update:profil', this.profil)
                            }

                            // achievements toast popup
                            this.$toast.success(' ', response.data.data)
                        })
                        .catch(error => {
                            this.responseType = 'warning'
                            this.responseText = error
                        })
                }
            },
        }
    }
</script>